export const iconFontAwesomeMapsLocationPinLock = (
	<i className="fa-solid fa-location-pin-lock"></i>
);
